<template>
  <v-app>
    <NavDrawer v-if="currentUser !== null" />
    <MenuBar v-if="currentUser === null" />

    <v-main>
<!--      <transition name="fade" mode="out-in">-->
        <router-view></router-view>
<!--      </transition>-->
    </v-main>

  </v-app>
</template>

<script>
import MenuBar from "./components/MenuBar";
import NavDrawer from "./components/NavDrawer.vue";


export default {
  name: 'App',
  components: {
    MenuBar,
    NavDrawer
  },
  data: () => ({
  }),
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    initIcon() {
      let link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      // link.href = this.icon;
      link.href = "favicon.ico";
      document.getElementsByTagName("head")[0].appendChild(link);
    },
  },
  created() {
    this.initIcon();
  },
  mounted() {
    this.initIcon();

    if (!this.currentUser) {
      //Kita tidak akan pernah push apapun jika belum login
      // this.$router.push('/login');
    }else {
      this.$store.dispatch('data/loadFDivision')
    }

    /**
     * AKAN DI BERIKAN VALIDATE EXPIRED TOKEN
     */

    // console.log(`Current user is ${JSON.stringify(this.currentUser)}`)
    // console.log("###### MOUNTED App.Vue PERTAMA KALI ####")
    // TestService.getAdminBoard().then(
    //     ()=>{
    //     },
    //     error=>{
    //       console.log(`${error.response.status}`)
    //       if (error.response.status===401){
    //         this.$store.dispatch('auth/logout');
    //         // this.$router.push('/login'); //tidak diarahkan kemana mana donk
    //
    //       }
    //     }
    // )
  },
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
.color-gradient-1 {
  background-image: linear-gradient(to top left, #1a7d53 10%, transparent 90%);
}
.color-bg-primary {
  background-color: #FF8030;
}
.color-bg-second {
  background-color: #135B51FF;
}
.color-text-primary {
  color: #FF8030;
}
.color-text-second {
  color: #135B51FF;
}
.bottom-gradient {
  background-image: linear-gradient(to top left, #1d7a52 10%, transparent 90%);
}

.repeating-gradient {
  background-image: repeating-linear-gradient(
      -45deg,
      rgba(255, 0, 0, 0.25),
      rgba(255, 0, 0, 0.25) 5px,
      rgba(0, 0, 255, 0.25) 5px,
      rgba(134, 134, 234, 0.25) 10px
  );
}
.navbar_submenu_color {
  background-color: #c8efe0;
}
</style>